import deDE from './locales/de-DE.json'
import enUS from './locales/en-US.json'
import esES from './locales/es-ES.json'
import frFR from './locales/fr-FR.json'
import itIT from './locales/it-IT.json'
import ptBR from './locales/pt-BR.json'

export const messages: { [key: string]: { [key: string]: string } } = {
  'en-US': enUS,
  'fr-FR': frFR,
  'pt-BR': ptBR,
  'de-DE': deDE,
  'es-ES': esES,
  'it-IT': itIT,
}
